import type { KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isKycRequired(kycInfo?: KycResponse | null) {
  return Boolean(kycInfo?.activeProcess);
}
